import * as yup from 'yup';
import { DateTime } from 'luxon';
import { AccordionEditDataControl } from 'shell/view-models/edit-data-control';
import { idActRegex } from 'shell/constants/regex';
import { ActType } from 'shell/constants/act-type';
import { DocumentDigital } from 'shell/view-models/act-form';
// import { MunicipalityAnprVM } from 'shell/components/shared/municipality-list';

export const validationSchema = yup.object().shape({
  editDataControl: yup
    .object()
    .nullable()
    .shape({
      dateValidity: yup
        .date()
        .typeError('Data non valida')
        .nullable()
        .required('campo obbligatorio'),
    })
    .test(
      'editDataControl.dateValidity',
      'La data deve essere minore uguale del giorno corrente',
      (values) => {
        const castedValues = values as unknown as AccordionEditDataControl;

        if (castedValues.dateValidity && castedValues.dateValidity > DateTime.now()) {
          return new yup.ValidationError(
            'La data deve essere minore uguale del giorno corrente',
            undefined,
            'editDataControl.dateValidity'
          );
        }

        return true;
      }
    ),
  cancelCivilUnion: yup
    .object()
    .nullable()
    .shape({
      eventDate: yup.date().required('Campo obbligatorio').typeError('Data non valida').nullable(),
      reasonCancel: yup.string().required('Campo obbligatorio'),
      actType: yup.string(),
      digital: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoDigitale,
          otherwise: yup.object().nullable(),
          then: yup
            .object()
            .nullable()
            .shape({
              idAnsc: yup
                .string()
                .nullable()
                .matches(idActRegex, 'Formato non corretto')
                .test((value) => {
                  if (value) {
                    const [year] = value.split('-');
                    const isValid = year ? Number.parseInt(year) >= 2022 : true;

                    return isValid
                      ? true
                      : new yup.ValidationError(
                          "L'idAnsc deve avere anno maggiore al 2022",
                          undefined,
                          'cancelCivilUnion.digital.idAnsc'
                        );
                  }
                  return true;
                })
                .required('Campo richiesto'),
              documentDate: yup.date().nullable().notRequired().typeError('Formato non valido'),
              municipality: yup.object().shape({}).nullable().required('Campo richiesto'),
            })
            .test((values) => {
              const castedValues = values as unknown as DocumentDigital;

              if (
                castedValues?.municipality?.id &&
                castedValues?.istatCode &&
                castedValues?.municipality?.id === castedValues.istatCode
              ) {
                return true;
              }
              return new yup.ValidationError([
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'cancelCivilUnion.digital.municipality'
                ),
                new yup.ValidationError(
                  'Non coincidono i due codici ISTAT',
                  undefined,
                  'cancelCivilUnion.digital.istatCode'
                ),
              ]);
            }),
        }),
      paper: yup
        .object()
        .nullable()
        .when('actType', {
          is: ActType.AttoCartaceo,
          otherwise: yup.object().nullable(),
          then: yup.object().shape({
            actDate: yup
              .date()
              .nullable()
              .max(
                DateTime.local().plus({ days: 1 }),
                'La data non può essere successiva alla data odierna'
              )
              .typeError('Data non valida'),
            transcribed: yup.string().nullable(),
            actMunicipality: yup.object().nullable().shape({}).required('Il campo è richiesto'),
            actYear: yup
              .number()
              .nullable()
              .required('Campo richiesto')
              .typeError('Sono ammesse solamente cifre'),
            actNumber: yup
              .number()
              .nullable()
              .required('Campo richiesto')
              .typeError('Sono ammesse solamente cifre'),
            actPart: yup
              .string()
              .nullable()
              .required('Campo richiesto')
              .test(
                'part-ammisible-values',
                'Gli unici valori ammessi sono 1 o 2',
                (value) => ['1', '2'].indexOf(value || '') >= 0
              ),
            actSeries: yup.string().nullable(),
            actVolume: yup
              .string()
              .nullable()
              .when('actMunicipality.description', {
                is: (description: string) => (description || '').toLocaleLowerCase() === 'milano',
                then: yup
                  .string()
                  // .required('Campo obbligatorio')
                  .matches(/^R[0-9]{2}$/, {
                    message:
                      'Per il comune di Milano il volume è formato da R e due cifre(es. R00)',
                  }),
              }),
          }),
        }),
    }),
});
